export const sanitizeToPlainText = (htmlString: string) => {
  const allowedTags = "(b|i|u|strong|em|strike|s)";

  return htmlString
    .replace(new RegExp(`<(${allowedTags})[^>]*>`, "gi"), "")
    .replace(new RegExp(`<\/(${allowedTags})>`, "gi"), "");
};
